// extracted by mini-css-extract-plugin
export default {"joinStravaCTA":"JoinStravaCTA--joinStravaCTA--qx+r7","joinStravaCta":"JoinStravaCTA--joinStravaCTA--qx+r7","link":"JoinStravaCTA--link--AQ-6U"};